import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import { useApplicationStandaloneStoreActions } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { computed } from "@vue/composition-api";
export const useLiabilityFieldBindings = options => {
  const {
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentLiabilityPath = computed(() => {
    return `${currentApplicantPath.value}[liabilities][${options.liabilityIndex.value}]`;
  });
  const {
    TRANSFER_APPLICANT_FIELD_BY_PATH
  } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.TRANSFER_APPLICANT_FIELD_BY_PATH]);
  const liabilityOwner = computed({
    get() {
      return options.applicantIndex.value;
    },
    set(newApplicantIndex) {
      if (typeof newApplicantIndex !== "number") return;
      const sourcePath = currentApplicantPath.value + "[liabilities]";
      const applicantPath = newApplicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : `${APPLICATION_PATH.CO_APPLICANTS}[${newApplicantIndex - 1}]`;
      const targetPath = applicantPath + "[liabilities]";
      TRANSFER_APPLICANT_FIELD_BY_PATH({
        sourcePath,
        targetPath,
        sourceElementIndex: options.liabilityIndex.value
      });
    }
  });
  const liabilityType = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[type]"), "");
  const liabilityLimit = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[limit]"), 0);
  const liabilityBalance = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[balance]"), 0);
  const liabilityPayment = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[payment]"), 0);
  const liabilityMaturityDate = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[maturity-date]"), "");
  const liabilityPayoff = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[payoff]"), "");
  const liabilityDescription = bindApplication(makeFieldPathReactive(currentLiabilityPath, "[description]"), "");
  return {
    liabilityType,
    liabilityOwner,
    liabilityLimit,
    liabilityBalance,
    liabilityPayment,
    liabilityMaturityDate,
    liabilityPayoff,
    liabilityDescription
  };
};